<div class="lite-plan-window-container modal-window-container fx-cover fx-center-all" #container (click)="closeWindow()">
    <div class="lite-plan-window-inner" #window>
        <iframe #litePlanWindowFrame [src]="litePlanWindowUrl | safe" class="lite-plan-window-iframe"></iframe>
    </div>
</div>